import FilePresentIcon from '@mui/icons-material/FilePresent';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Box
} from '@mui/material';
import ButtonEditar from './ButtonEditar';
import DocEdit from './docEdit';

export default function DocumentItem({
  label,
  file,
  docKey,
  estabelecimentoId,
  id,
  url,
  isEditing,
  onToggleEdit,
  onPreview
}) {
  const hasFile = Boolean(file);


  return (
    <>
      <ListItem secondaryAction={<ButtonEditar edit={isEditing} setEdit={onToggleEdit} />}>
        <ListItemIcon>
          {hasFile ? (
            <CheckCircleIcon color="success" />
          ) : (
            <CancelIcon color="error" />
          )}
        </ListItemIcon>

        <ListItemText
          primary={
            hasFile ? (
              <Box
                component="span"
                sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 1 }}
                onClick={() => onPreview(file)}
              >
                <FilePresentIcon fontSize="small" color="secondary" />
                {label}
              </Box>
            ) : (
              `Faltou ${label}`
            )
          }
        />
      </ListItem>

      {isEditing && (
        <Box ml={7} mb={1}>
          <DocEdit
            id={id}
            url={url}
            estabelecimentoId={estabelecimentoId}
            nomeDoc={docKey}
            label={label}
          />
        </Box>
      )}
    </>
  );
}
